import { GzToastNotificationWebComponent } from './component/GzToastNotificationWebComponent';
import { WEB_COMPONENT_GZ_TOAST, WEB_COMPONENT_GZ_TOAST_WRAPPER } from '../../webcomponents.constants';
import { GzToastElement } from './component/GzToastElement';
import { ToastSeverity } from './type';

export { GzToastNotificationWebComponent, GzToastElement };

export function showErrorToast(errorMessage: string) {
  GzToastNotificationWebComponent.buildToastWrapperElement({
    message: errorMessage,
    severity: ToastSeverity.ERROR,
  });
}

export function showSuccessToast(successMessage: string) {
  GzToastNotificationWebComponent.buildToastWrapperElement({
    message: successMessage,
    severity: ToastSeverity.SUCCESS,
  });
}

window.customElements.define(WEB_COMPONENT_GZ_TOAST_WRAPPER, GzToastNotificationWebComponent);
window.customElements.define(WEB_COMPONENT_GZ_TOAST, GzToastElement);
